import { MouseEvent, ReactNode } from 'react';
import { Link } from 'react-router-dom';

const actionClass =
  'relative inline-flex items-center gap-2 text-sm font-medium text-primary leading-5 before:absolute before:inset-x-0 before:top-0 before:-bottom-6 focus-ring rounded-sm';

export default function QuietAction({
  children,
  icon,
  label,
  to,
  onClick,
}: {
  children: string;
  icon?: ReactNode;
  label?: string;
  to: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
}) {
  return (
    <Link to={to} aria-label={label ?? children} onClick={onClick} className={actionClass}>
      {icon}
      {children}
    </Link>
  );
}
